import { Typography } from "@mui/material";
import { sectionTitleStyle } from "./CouponStyles";

export const SectionTitle: React.FC<{ children: string }> = ({ children }) => {
    return <Typography sx={sectionTitleStyle}>{children}</Typography>;
};
